<template>
	<div id="multiselectnote">
		<div class="dropdown dropdown-filter" @click="showDropdown">
			<div class="overselect"></div>
			<div class="c-form-input">
				<h3 class="raleway-semi-p13">Green Note</h3>
				<img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
				<img src="../../images/flechebas-simple.svg" v-set-alt v-else />
			</div>
		</div>
		<div class="multiselect" v-if="show & !isPhone">
			<ul>
				<div class="row row-selectoptions mt-3">
					<div class="col-6">
						<li>
							<input type="checkbox" id="10" value="10" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="10">
								<img src="../../images/greennote 10.svg" v-set-alt class="mr-2" />
								10/10 <span class="filter-count">({{ getScoreCount(10) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="9" value="9" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="9">
								<img src="../../images/greennote 9.svg" v-set-alt class="mr-2" />
								9/10 <span class="filter-count">({{ getScoreCount(9) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="8" value="8" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="8">
								<img src="../../images/greennote 8.svg" v-set-alt class="mr-2" />
								8/10 <span class="filter-count">({{ getScoreCount(8) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="7" value="7" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="7">
								<img src="../../images/greennote 7.svg" v-set-alt class="mr-2" />
								7/10 <span class="filter-count">({{ getScoreCount(7) || 0 }})</span>
							</label>
						</li>
					</div>
					<div class="col-6">
						<li>
							<input type="checkbox" id="6" value="6" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="6">
								<img src="../../images/greennote 6.svg" v-set-alt class="mr-2" />
								6/10 <span class="filter-count">({{ getScoreCount(6) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="5" value="5" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="5">
								<img src="../../images/greennote 5.svg" v-set-alt class="mr-2" />
								5/10 <span class="filter-count">({{ getScoreCount(5) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="4" value="4" v-model="selected" />
							<label class="raleway-reg-p13 ml-2" for="4">
								<img src="../../images/greennote 4.svg" v-set-alt class="mr-2" />
								4/10 <span class="filter-count">({{ getScoreCount(4) || 0 }})</span>
							</label>
						</li>
					</div>
				</div>
			</ul>
		</div>
		<div class="multiselect" v-if="show & isPhone">
			<ul class="m-0">
				<div class="row-selectoptions mt-3">
						<div class="d-flex">
              <li>
                <input type="checkbox" id="10" value="10" v-model="selected" />
                <label class="raleway-reg-p13" for="10">
                  10/10 <span class="filter-count">({{ getScoreCount(10) || 0 }})</span>
                </label>
              </li>
              <li>
                <input type="checkbox" id="9" value="9" v-model="selected" />
                <label class="raleway-reg-p13 ml-2" for="9">
                  9/10 <span class="filter-count">({{ getScoreCount(9) || 0 }})</span>
                </label>
              </li>
              <li>
                <input type="checkbox" id="8" value="8" v-model="selected" />
                <label class="raleway-reg-p13 ml-2" for="8">
                  8/10 <span class="filter-count">({{ getScoreCount(8) || 0 }})</span>
                </label>
              </li>
            </div>
						<div class="d-flex">
              <li>
                <input type="checkbox" id="7" value="7" v-model="selected" />
                <label class="raleway-reg-p13" for="7">
                  7/10 <span class="filter-count">({{ getScoreCount(7) || 0 }})</span>
                </label>
              </li>
              <li>
                <input type="checkbox" id="6" value="6" v-model="selected" />
                <label class="raleway-reg-p13 ml-2" for="6">
                  6/10 <span class="filter-count">({{ getScoreCount(6) || 0 }})</span>
                </label>
              </li>
              <li>
                <input type="checkbox" id="5" value="5" v-model="selected" />
                <label class="raleway-reg-p13 ml-2" for="5">
                  5/10 <span class="filter-count">({{ getScoreCount(5) || 0 }})</span>
                </label>
              </li>
              <li>
                <input type="checkbox" id="4" value="4" v-model="selected" />
                <label class="raleway-reg-p13 ml-2" for="4">
                  4/10 <span class="filter-count">({{ getScoreCount(4) || 0 }})</span>
                </label>
              </li>
            </div>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'multiselectnote',
		props: ['filterCounts'],
		emits: ['checked'],
		data() {
			return {
				show: false,
				selected: [],
			};
		},
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        }else{
          return false;
        }
      },
    },
		methods: {
			showDropdown() {
				this.show = !this.show;
			},
			getScoreCount(score) {
				if (!this.filterCounts || !this.filterCounts.green_score_rounded) return 0;
				const scoreData = this.filterCounts.green_score_rounded.find(s => s.key === score);
				return scoreData ? scoreData.count : 0;
			},
		},
		watch: {
			selected(val) {
				this.$emit('checked', val, 'score');
			},
		},
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
